import PageList from "../../abstract/PageList.js";
import { SecurityAcl, AuthCheckAcl } from "../../../Security.js";
import AgGridWrapper from "../../../su/AgGridWrapper.js";
import { ModalAlert, ModalConfirm } from "../../../su/Modals.js";

export default class PageDeliveriesList extends PageList {
    constructor() {
        super();
    }

    init($data) {
        super.init($data);
        $(".jsBtnExport").on("click", this.exportList.bind(this, undefined));

    }
     
    getAvailableHeight() {
        let a = jQuery(".js-size");
        let i = 0;
        for (let x = 0; x < a.length; x++) {
            i += jQuery(a[x]).outerHeight();
        }
        i += 50; // padding app container
        i += 78; // search box
        i += 143; // paging
        let h = jQuery(window).height() - i;
        return h;
    }
    initAgList() {
        const rowData = [];
        for (let x = 0; x < this.data.rows.length; x++) {
            const row = this.data.rows[x];
            rowData.push(row);
        }
        this.rowData = rowData;

        const searchBox = document.getElementById("filter-text-box");

        const targetGrid = document.querySelector(".js-aglist");
        const h = this.getAvailableHeight();
        targetGrid.style.height = h + "px";
        const columnDefs = [
            {
                field: "ContractID",
                headerName: "Cod. contratto",
                filter: "agMultiColumnFilter",
                width: 150
            },
            {
                field: "CustomerName",
                headerName: "Nome cliente",
                filter: "agMultiColumnFilter",
                width: 300,
            },
            {
                field: "VehicleDescription",
                headerName: "Descrizione veicolo",
                filter: "agMultiColumnFilter",
                width: 250
            },
            {
                field: "LicensePlate",
                headerName: "Targa",
                filter: "agMultiColumnFilter",
                width: 150,
            },
            {
                field: "FirstRegistrationDate",
                headerName: "Data immatricolazione",
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                width: 200,
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "ChassisNumber",
                headerName: "Telaio",
                filter: "agMultiColumnFilter",
                width: 215
            },
            {
                field: "Dealer",
                headerName: "Fornitore",
                filter: "agMultiColumnFilter",
                width: 200
            },
            {
                field: "MandatoryDeliveryDate",
                headerName: "Tassativa",
                width: 200,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "AthlonSLADeliveryDate",
                headerName: "Data consegna prevista SLA",
                width: 200,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "HasCustomEquipment",
                headerName: "Allestimento",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "EquipmentProviderName",
                headerName: "Ubicazione attuale",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "RecallCampaign",
                headerName: "Campagna di richiamo",
                hide: true,
                getQuickFilterText: () => '',
            },

            {
                field: "IsReadyForPickup",
                headerName: "Disponibile al ritiro",
                filter: "agMultiColumnFilter",
                width: 150
            },
            {
                field: "TransportAssignmentDate",
                headerName: "Data incarico trasporto",
                width: 200,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "TransporterName",
                headerName: "Trasportatore",
                filter: "agMultiColumnFilter",
                width: 300
            },
            {
                field: "IsOnIsland",
                headerName: "Consegna su isole",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ASPDelivery",
                headerName: "ASP",
                filter: "agMultiColumnFilter",
                width: 200
            },
            {
                field: "ASPDeliveryPhone",
                headerName: "ASP telefono",
                filter: "agMultiColumnFilter",
                width: 200
            },
            {
                field: "ExpectedASPDeliveryDate",
                headerName: "Data prevista arrivo su ASP",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "TransportDelayed",
                headerName: "Ritardo trasporto",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ActualASPArrivalDate",
                headerName: "Data conferma arrivo su ASP",
                width: 200,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "DeliveryConfirmed",
                headerName: "Conferma consegna",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "TransportDelayDays",
                headerName: "Ritardo gg trasporto",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "PreparationDelayed",
                headerName: "Ritardo Approntamento",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ExpectedInstallationDate",
                headerName: "Data prevista fine approntamento",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "NewPreparationDate",
                headerName: "Nuova Data Approntamento",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "PreparationDelayDays",
                headerName: "Ritardo gg approntamento",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "BlackBoxInstallationDate",
                headerName: "Data previsto montaggio BB",
                width: 200,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "SatelliteSystem",
                headerName: "Tipologia BB",
                filter: "agMultiColumnFilter",
                width: 200
            },
            {
                field: "BlackBoxInstallationConfirmed",
                headerName: "Conferma montaggio BB",
                filter: "agMultiColumnFilter",
                width: 150
            },
            {
                field: "WinterTiresType",
                headerName: "Previste winter",
                filter: "agMultiColumnFilter",
                width: 150
            },
            {
                field: "WinterTiresInstallNeeded",
                headerName: "Montaggio winter",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "WinterTiresInstallDelayed",
                headerName: "Ritardo Montaggio",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ActualWinterTiresInstallDate",
                headerName: "Nuova data fine montaggio",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "WinterTiresDelayReason",
                headerName: "Motivazione ritardo",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ExpectedWinterTiresInstallDate",
                headerName: "Data prevista montaggio winter",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "WinterTiresDelayDays",
                headerName: "GG ritardo montaggio Winter",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "TransportDamageDetected",
                headerName: "Danni da trasporto / anomalie",
                filter: "agMultiColumnFilter",
                width: 150
            },
            {
                field: "DamageRepairDelayed",
                headerName:"Ritardo riparazione danni",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "NewDamageRepairEndDate",
                headerName: "Nuova data riparazione danni",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ExpectedDamageRepairDate",
                headerName: "Data prevista riparazioni danni",
                cellClass: "dateITExcel",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "DamageRepairDelayDays",
                headerName: "Ritardo gg riparazione danni",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "DamageRepairDelayReason",
                headerName: "Motivazione ritardo",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "TotalAccumulatedDelay",
                headerName: "Ritardo gg accumulato complessivo su intero processo",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "CycleTime",
                headerName: "CYCLE TIME",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ActualReadyForCustomerDate",
                headerName: "Pronta ASP",
                width: 250,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "MADSentDate",
                headerName: "Mad inviata",
                width: 200,
                filter: 'agDateColumnFilter',
                filterParams: {
                    comparator: this.dateFilterComparator.bind(this),
                    browserDatePicker: true,
                },
                cellClass: "dateITExcel",
                type: AgGridWrapper.TYPE_DATE
            },
            {
                field: "GraceDays",
                headerName: "Grace days",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "ContractActive",
                headerName: "Contratto attivo",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "Verbale",
                headerName: "Verbale",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "Notes",
                headerName: "NOTE",
                hide: true,
                getQuickFilterText: () => '',
            },
            {
                field: "StatusLabel",
                headerName: "Bloccato",
                filter: "agMultiColumnFilter",
                getQuickFilterText: () => '',
            }
        ];

        // Inizializzazione della griglia (Copia incolla tranne il primo parametro che è un id arbitrario ma usiamo generalmente il nome della pagina)
        let agGrid = new AgGridWrapper("PageDeliveryList", AgGridWrapper.MODE_SIMPLE);
        const options = agGrid.getConfig({
            paginationPageSize: 20,
            paginationPageSizeSelector: [20, 50, 100,200],
            onRowDoubleClicked: this.viewRow.bind(this),
            suppressContextMenu: true,
            suppressHorizontalScroll: false,

            enableCellTextSelection: false,
            cellSelection: true,

            suppressCopyRowsToClipboard: true,
            suppressCopySingleCellRanges: true,

            customOptions: {
                doNotshowSelection: true, // In modo casereccio non mostra la selezione
                removeOldList: false, // Rimuove la vecchia griglia dalla pagina (punta sul fatto che i nodi che la contengono si chiamino "jsList" e "filterbox" grazie al solito copia-incolla selvaggio).
            },
            defaultColDef: {
                floatingFilter: true,
                suppressHeaderMenuButton: true,
                suppressHeaderContextMenu: true,
                enableCellChangeFlash: false,
            },
            columnDefs,
            rowData,
            excelStyles: [
                {
                    id: "dateITExcel",
                    dataType: "DateTime",
                    numberFormat: {
                        format: "dd/mm/yyyy",
                    },
                },
            ]
        });

        // Crea la griglia e ascolta il resize della finestra per cambiare l'altezza
        agGrid.init(targetGrid, searchBox, options);
        this.gridApi = agGrid.agGrid;
        window.onresize = this.arrangeGrid.bind(this, agGrid);
        this.setupCopyHandler();
    }
    // fatta in questo modo perche ag-grid non fa ctrl + c per copiare il testo della cella
    // non copia le date formattate, ma le copia come timestamp
    setupCopyHandler() {
        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey && event.key === 'c') {
                const focusedCell = this.gridApi.getFocusedCell();
                if (focusedCell) {
                    const rowNode = this.gridApi.getDisplayedRowAtIndex(focusedCell.rowIndex);
                    const colDef = focusedCell.column.getColDef();
                    let cellValue;

                    if (colDef.valueFormatter) {
                        cellValue = colDef.valueFormatter({
                            value: this.gridApi.getValue(focusedCell.column, rowNode),
                            data: rowNode.data,
                            node: rowNode,
                            colDef: colDef
                        });
                    } else if (colDef.type === AgGridWrapper.TYPE_DATE) {
                        const rawValue = this.gridApi.getValue(focusedCell.column, rowNode);
                        if (rawValue) {
                            const dateObject = new Date(parseInt(rawValue));
                            cellValue = dateObject.toLocaleDateString("en-GB"); 
                        } else {
                            cellValue = '';
                        }
                    } else {
                        cellValue = this.gridApi.getValue(focusedCell.column, rowNode);
                    }

                    navigator.clipboard.writeText(String(cellValue || '')).catch(console.error);
                    event.preventDefault();
                }
            }
        });
    }

    arrangeGrid(agGrid) {
        // Punta alla griglia e ne imposta l'altezza
        const h = this.getAvailableHeight();
        agGrid.targetGrid.style.height = h + "px";
    }


    viewRow(params) {
        this.createSelection(params)
    }

    dateFilterComparator(filterLocalDateAtMidnight, cellValue, filterType) {
        if (!cellValue) {
            return -1;
        }

        try {
            const [day, month, year] = cellValue.split('/').map(Number);
            const cellDate = new Date(year, month - 1, day);

            if (isNaN(cellDate.getTime())) {
                return -1;
            }

            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
            return 0;
        } catch (error) {
            return -1;
        }
    }

    async exportList(params) {
        this.showPreloader(true);

        try {
            if (this.gridApi && typeof this.gridApi.exportDataAsExcel === 'function') {

                function getWinterTiresDelayReasonLabel(uid) {
                    const reasons = TheProviders.winter_tire_delay_reason || [];
                    const found = reasons.find(r => r.Value === uid);
                    return found ? found.Label : uid || '';
                }

                function getDamageRepairDelayReasonLabel(uid) {
                    const reasons = TheProviders.damage_repair_delay_reason || [];
                    const found = reasons.find(r => r.Value === uid);
                    return found ? found.Label : uid || '';
                }

                function getStatusLabel(status) {
                    if (status == 2) {
                        return "No";
                    }
                    if (status == 0) {
                        return "Si";
                    }
                }

                const dateFields = [
                    "FirstRegistrationDate",
                    "AthlonSLADeliveryDate",
                    "TransportAssignmentDate",
                    "ActualASPArrivalDate",
                    "BlackBoxInstallationDate",
                    "ActualReadyForCustomerDate",
                    "MADSentDate",
                    "ExpectedASPDeliveryDate",
                    "ExpectedInstallationDate",
                    "ActualWinterTiresInstallDate",
                    "ExpectedWinterTiresInstallDate",
                    "NewDamageRepairEndDate",
                    "ExpectedDamageRepairDate",
                    "NewPreparationDate",
                    "ContractActiveDate",
                    "MandatoryDeliveryDate"
                ];

                const exportParams = {
                    skipFilteredRows: true,
                    allColumns: true,
                    fileName: 'deliveries-export.xlsx',
                    onlySelected: false,
                    exportedRows: 'filteredAndSorted',
                    processCellCallback: params => {
                        if (dateFields.includes(params.column.getColId())) {
                            if (!params.value) return "";
                            const timestamp = Number(params.value);
                            if (isNaN(timestamp) || timestamp <= 0) return "";
                            const date = new Date(timestamp);
                            date.setDate(date.getDate() + 1);
                            return isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
                        }
                        if (params.column.getColId() === "WinterTiresDelayReason") {
                            return getWinterTiresDelayReasonLabel(params.value);
                        }
                        if (params.column.getColId() === "DamageRepairDelayReason") {
                            return getDamageRepairDelayReasonLabel(params.value);
                        }
                        if (params.column.getColId() === "Status") {
                            return getStatusLabel(params.value);
                        }
                        return params.value;
                    }
                };

                const originalExportDataAsExcel = this.gridApi.exportDataAsExcel;
                this.gridApi.exportDataAsExcel = (params) => {
                    const result = originalExportDataAsExcel.call(this.gridApi, params);
                    setTimeout(() => {
                        this.showPreloader(false);
                    }, 500);
                    return result;
                };

                this.gridApi.exportDataAsExcel(exportParams);
                return;
            } else {
                this.showPreloader(false);
            }
        } catch (error) {
            this.showPreloader(false);
        }
    }

    // should also work with quick filter
    createSelection(params) {
        let filterModel = params.api.getFilterModel();
        let hasFilter = true;
        // get value of quickFilter id filter-text-box
        let quickFilter = document.getElementById("filter-text-box");
        if (quickFilter && quickFilter.value && quickFilter.value.length > 0) {
            filterModel["quickFilter"] = {
                type: "contains",
                filter: quickFilter.value,
            };
        }
        if (!filterModel || Object.keys(filterModel).length === 0) hasFilter = false;

        let stringUids = "";
        if (hasFilter) {
            let apiRows = [];
            params.api.forEachNodeAfterFilterAndSort(function (node) {
                apiRows.push(node);
            });

            for (let i = 0; i < apiRows.length; i++) {
                let row = apiRows[i];
                if (row.data && row.data.Uid) {
                    if (stringUids.length > 0) stringUids += "|";
                    stringUids += row.data.Uid;
                }
            }


            this.showPreloader(true);
            let rq = {
                Key: "selected",
                Value: stringUids,
            };
            thatServiceManeger.standardCall("api/helper/sessionstore/save", rq, this.onSaveSessionStoreHandler.bind(this, params, hasFilter));
        } else {
            const nextUrl = TheApp.Env.BaseUrlNls + "deliveries/detail/" + Base64.toBase64(params.data.Uid, true) + "?__pi=" + this.data.page.PageId;
            window.location.href = nextUrl;
        }
    }

    onSaveSessionStoreHandler(params, hasFilter, rs) {
        if (rs && rs.Success) {
            this.showPreloader(false);
            let nextUrl = TheApp.Env.BaseUrlNls + "deliveries/detail/" + Base64.toBase64(params.data.Uid, true) + `?filter=${hasFilter}&__pi=` + this.data.page.PageId;
            window.location.href = nextUrl;
            return;
        } else {
            this.showPreloader(false);
            toastr.error("Si è verificato un'errore nel caricamento della pagina. Riprova!");
        }
    }
}
